import { ActionEffectivenessCompliance } from 'frontcore/presentation/actions/domain/types'
import { HSE_RISKS_SOURCE } from "frontcore/constants/constants"

export const IDENTIFIED = 0
export const PLANIFIED = 1
export const ONGOING = 2
export const DONE = 3
export const VERIFIED = 4
export const EXPIRED = 100
export const ALL_ACTIONS_STATUS = [IDENTIFIED, PLANIFIED, ONGOING, DONE, VERIFIED, EXPIRED]

export const MAX_NUMBER_OF_CHARACTERS = 300

export const ACTIONS_TYPE_CORRECTIVE = 1
export const ACTIONS_TYPE_PREVENTIVE = 2
export const ACTIONS_TYPE_CONTAINMENT = 3

export const UNKNOWN_SOURCE = '*'

export const MPS_ACTIONS_LIST_URL = `${MPS_URL}/actions/list`

export const MAX_TIMES_ESCALATED_ICON = 3

export const ACTION_EFFECTIVENESS_COMPLIANCE_OPTIONS = [
  {
    'label': 'common.messages.yes_message',
    'value': ActionEffectivenessCompliance.Yes,
  },
  {
    'label': 'common.messages.no_message',
    'value': ActionEffectivenessCompliance.No,
  },
  {
    'label': 'common.messages.partially',
    'value': ActionEffectivenessCompliance.Partially,
  },
]

const items = Object.freeze({
  0: {
    class: 'status-identified',
    color: '#4D7EF7',
    icon: 'identified',
    id: 0,
    name: 'actions.messages.identified',
  },
  1: {
    class: 'status-planified',
    color: '#535353',
    icon: 'planned',
    id: 1,
    name: 'actions.messages.planified',
  },
  2: {
    class: 'status-on-going',
    color: '#F3A942',
    icon: 'circle-hammer',
    id: 2,
    name: 'actions.messages.on_going',
  },
  3: {
    class: 'status-finalised',
    color: '#70B7A2',
    icon: 'finalised',
    id: 3,
    name: 'actions.messages.finalised',
  },
  4: {
    class: 'status-verified',
    color: '#6ECA47',
    icon: 'verified',
    id: 4,
    name: 'actions.messages.verified',
  },
})

function actionSourceUrls () {
  const webAppUrlBySource = {
    [HSE_RISKS_SOURCE]: getWebHseUrl,
  }

  function getWebHseUrl (action) {
    const {id: riskId} = action.details
    return new URL(`/apps/webhse/perimeters/${action.perimeter}/risks/${riskId}/details`, MPS_URL).href
  }

  function getActionSource (action) {
    return action.source?.split('.').pop()
  }

  return {
    getWebAppUrl (action) {
      const source = getActionSource(action)
      return webAppUrlBySource[source]?.(action) ?? ''
    },
  }
}

export default {
  DONE,
  EXPIRED,
  IDENTIFIED,
  MAX_NUMBER_OF_CHARACTERS,
  ONGOING,
  PLANIFIED,
  VERIFIED,
  items,
  actionSourceUrls: actionSourceUrls(),
}
